module.exports = __webpack_public_path__ + "img/gift_icon_active.867e1ce1.svg";